export const LOAD_FOLDERS = 'LOAD_FOLDERS'
export const ADD_FOLDER = 'ADD_FOLDER'
export const UPDATE_FOLDER = 'UPDATE_FOLDER'